<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-29 11:26:04
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-29 11:26:53
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/myActivities/list/components/tableCell/leaderInfoCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-tooltip placement="top" :open-delay="300" :content="row.institution_name">
			<div class="font-h6-medium fz-12">{{ row.institution_name | formatEmpty | textFormat(10) }}</div>
		</el-tooltip>
		<el-tooltip placement="top" :open-delay="300">
			<div slot="content">
				<span>ID</span>
				<span class="ml-4">{{ row.authority_id | formatEmpty }}</span>
				<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="$copy(row.authority_id)"></i>
			</div>
			<div class="font-h6-medium fz-12 command_id">ID：{{ row.authority_id | formatEmpty | textFormat(10) }}</div>
		</el-tooltip>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
};
</script>
